import React from 'react';

import { setTheme } from '@ui5/webcomponents-base/dist/config/Theme';
import { ThemeProvider as UI5ThemeProvider } from '@ui5/webcomponents-react';

import '@ui5/webcomponents-react/dist/Assets';
import { env } from 'config/env';

export const withTheme = (Component: React.ComponentType): React.ComponentType => {
  const theme = env?.REACT_APP_USE_HORIZON_THEME === 'true' ? 'horizon' : 'sap_fiori_3';
  setTheme(theme);
  const WrappedComponent: React.FC = () => (
    <UI5ThemeProvider>
      <Component />
    </UI5ThemeProvider>
  );
  WrappedComponent.displayName = `withTheme`;
  return WrappedComponent;
};
